export interface CompaniesResetTagFilterActionType {
  type: '@companies/RESET_TAG_FILTER';
}

export const resetTagFilter = (): CompaniesResetTagFilterActionType => ({
  type: '@companies/RESET_TAG_FILTER',
});
